import {Action, Module, Mutation} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {LogdownLogger} from '@/utils/LogdownLogger';
import {ILogger} from '@/utils/ILogger';

import {LoraPacketForwarderStats} from '@/model/lora/LoraPacketForwarderStats';

import {LoraForwarderUdpService} from '@/services/lora/forwarder/LoraForwarderUdp.service';
import {ILoraForwarderUdpService} from '@/services/lora/forwarder/ILoraForwarderUdp.service';
import {IEventsService} from '@/services/IEvents.service';

import {LoraForwarderStore} from '@/store/lora/LoraForwarder.store';
import {LoraForwarderState} from '@/model/lora/LoraForwarderState';
import {JobOutputMessage} from '@/model/lora/JobOutputMessage';
import {ILoraForwarderStatsStore} from '@/store/lora/ILoraForwarderStats.store';
import {LoraPacket} from '@/model/lora/LoraPacket/LoraPacket';
import {ILoraForwarderFrequencyPlanStore} from '@/store/lora/ILoraForwarderFrequencyPlan.store';
import {FrequencyPlan} from '@/model/lora/FrequencyPlan';

@Module({name: 'LoraForwarderUdpStore', namespaced: true})
export default class LoraForwarderUdpStore extends LoraForwarderStore implements ILoraForwarderStatsStore, ILoraForwarderFrequencyPlanStore {
  protected logger: ILogger = new LogdownLogger('LoraForwarderUdpStore');

  @Inject(Symbol.for('IEventsService'))
  protected eventsService!: IEventsService;

  protected forwarderService: ILoraForwarderUdpService = new LoraForwarderUdpService();

  protected stats: LoraPacketForwarderStats | null = null;

  protected frequencyPlan: FrequencyPlan | null = null;

  protected frequencyPlans: FrequencyPlan[] | null = null;

  public get Enabled(): boolean | null {
    return this.enabled;
  }

  public get State(): LoraForwarderState {
    return this.forwarderState;
  }

  public get Logs(): JobOutputMessage[] {
    return this.logs;
  }

  public get Packets(): LoraPacket[] {
    return this.packets;
  }


  /* Stats */
  @Action({commit: 'setStats', rawError: true})
  public async fetchStats(): Promise<LoraPacketForwarderStats> {
    return await this.forwarderService.getStats();
  }

  @Action({rawError: true})
  public async resetStats(): Promise<void> {
    await this.forwarderService.resetStats();

    this.context.commit('setStats', new LoraPacketForwarderStats());
  }

  @Mutation
  public setStats(stats: LoraPacketForwarderStats) {
    this.stats = stats;
  }

  get Stats(): LoraPacketForwarderStats | null {
    return this.stats;
  }

  /* Frequency plan */
  @Action({commit: 'setFrequencyPlan', rawError: true})
  public async fetchFrequencyPlan(): Promise<FrequencyPlan> {
    return await this.forwarderService.getFrequencyPlan();
  }

  @Mutation
  public setFrequencyPlan(frequencyPlan: FrequencyPlan) {
    this.frequencyPlan = frequencyPlan;
  }

  public get FrequencyPlan(): FrequencyPlan | null {
    return this.frequencyPlan;
  }

  /* Frequency plans */
  @Action({commit: 'setFrequencyPlans', rawError: true})
  public async fetchFrequencyPlans(): Promise<FrequencyPlan[]> {
    return await this.forwarderService.getFrequencyPlans();
  }

  @Mutation
  public setFrequencyPlans(frequencyPlans: FrequencyPlan[]) {
    this.frequencyPlans = frequencyPlans;
  }

  public get FrequencyPlans(): FrequencyPlan[] | null {
    return this.frequencyPlans;
  }
}
